export const PROCESS_COURSE_SUCCESS = "PROCESS_COURSE_SUCCESS";
export const PROCESS_COURSE_FAILED = "PROCESS_COURSE_FAILED";

export const LOAD_COURSES_SUCCESS = "LOAD_COURSES_SUCCESS";
export const LOAD_COURSES_BY_CATEGORY_TYPE_SUCCESS = "LOAD_COURSES_BY_CATEGORY_TYPE_SUCCESS"; // prettier-ignore
export const LOAD_COURSES_BY_TYPE_SUCCESS = "LOAD_COURSES_BY_TYPE_SUCCESS";
export const LOAD_COURSE_SUCCESS = "LOAD_COURSE_SUCCESS";
export const LOAD_COURSE_LOADING = "LOAD_COURSE_LOADING";
export const LOAD_COURSE_FAILED = "LOAD_COURSE_FAILED";
